import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

const generateBodyBagTag = httpsCallable(functions, "generateBodyBagTag");

/**
 * Generates a body bag tag PDF and returns an object URL for it.
 *
 * @param {object} data
 * @param {number|string} data.tagNumber
 * @param {string} [data.petName]
 * @param {string} [data.species]
 * @param {string} [data.otherSpecies]
 * @param {string} [data.furColor]
 * @param {number|string} [data.weight]
 * @param {string} [data.aquamationType]
 * @param {string} [data.ownerName]
 * @param {string} [data.submitterInfo]
 * @param {string} data.practiceName
 * @param {object} data.brand - brand object from getBrand()
 * @returns {Promise<string>} blob object URL
 */
export async function createBodyBagTagObjectURL(data) {
  const res = await generateBodyBagTag({
    tagNumber: parseInt(data.tagNumber),
    petName: data.petName,
    species: data.species,
    otherSpecies: data.otherSpecies,
    furColor: data.furColor,
    weight: data.weight,
    aquamationType: data.aquamationType,
    ownerName: data.ownerName,
    submitterInfo: data.submitterInfo,
    practiceName: data.practiceName,
    brand: data.brand,
  });

  const bytes = Uint8Array.from(atob(res.data.pdfBase64), (character) =>
    character.charCodeAt(0)
  );
  return URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
}

/**
 * Generates a body bag tag PDF and opens it in a new tab.
 * Opens the tab before the await so pop-up blockers don't catch it.
 *
 * @param {object} data - same shape as createBodyBagTagObjectURL
 */
export async function openBodyBagTagPDF(data) {
  const tab = window.open("", "_blank");

  try {
    const url = await createBodyBagTagObjectURL(data);

    if (tab) {
      tab.location = url;
    } else {
      window.open(url, "_blank");
    }
  } catch (error) {
    console.log(error);
    if (tab) tab.close();
    alert("There was an error creating the tag. Please try again.");
    throw error;
  }
}
